<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
        <iq-card>

            <!-- Header Title -->
            <template v-slot:headerTitle>
                <h4 class="card-title"> {{ $t('grant_budget_management.budget_allocation') }} {{ $route.query.id ? $t('globalTrans.modify') : $t('globalTrans.entry') }}</h4>
            </template>

            <!-- Header Action -->
            <template v-slot:headerAction>
                <b-button variant="primary">
                    <router-link  :to="{ path: '/grant-allowance-service/budget-management/budget-allocation'}">Back</router-link>
                </b-button>
            </template>

            <!-- Body -->
            <template v-slot:body>
                <b-row>
                  <b-col xl="12" lg="12" sm="12">
                    <b-overlay :show="formLoader" rounded="sm">
                      <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                        <b-form @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" enctype="multipart/form-data">
                          <b-row>
                            <!-- Organization -->
                            <b-col sm="12" md= "6" lg="6" xl="6">
                              <ValidationProvider name="Organization" vid="org_id" rules="required|min_value:1">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="5"
                                  label-for="org_id"
                                  slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                  {{$t('grant_budget_management.organization')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                  plain
                                  v-model="budget_allocation.org_id"
                                  :options="organizationList"
                                  id="org_id"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <!-- Fiscal Year -->
                            <b-col sm="12" md= "6" lg="6" xl="6">
                              <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="5"
                                  label-for="fiscal_year_id"
                                  slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                  {{$t('grant_budget_management.fiscal_year')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                  plain
                                  v-model="budget_allocation.fiscal_year_id"
                                  :options="fiscalYearList"
                                  id="fiscal_year_id"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <!-- service_type_id -->
                            <b-col sm="12" md= "6" lg="6" xl="6">
                              <ValidationProvider name="Service Type" vid="service_type_id_" rules="required|min_value:1">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    :label-for="'service_type_id_'"
                                    slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{$t('grant_budget_management.service_type')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="budget_allocation.service_type_id"
                                    id="service_type_id_"
                                    :options="serviceTypeList"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                  >
                                  <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <!-- service_id -->
                            <b-col sm="12" md= "6" lg="6" xl="6">
                              <ValidationProvider name="Service" vid="service_id_" rules="required|min_value:1">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    :label-for="'service_id_'"
                                    slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{$t('grant_budget_management.service_name')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="budget_allocation.service_id"
                                    id="service_id_"
                                    :options="serviceName"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                  >
                                  <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md= "6" lg="6" xl="6">
                              <ValidationProvider name="Total budget" vid='total_budget' :rules="{ required: true, regex: /^[1-9]\d*(\.\d{1,2})?$/ }">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="total_budget"
                                    slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{ $t('grant_budget_management.total_budget')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                      disabled
                                      id="total_budget"
                                      v-model="budget_allocation.total_budget"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    </b-form-input>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md= "6" lg="6" xl="6">
                              <ValidationProvider name="Available budget" vid='available_budget' :rules="{ required: true, regex: /^[1-9]\d*(\.\d{1,2})?$/ }">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="available_budget"
                                    slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{ $t('grant_budget_management.available_budget')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                      disabled
                                      id="available_budget"
                                      v-model="budget_allocation.available_budget"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    </b-form-input>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md= "6" lg="6" xl="6">
                              <ValidationProvider name="Committee type" vid="committee_type" rules="required|min_value:1">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    :label-for="'committee_type'"
                                    slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{$t('grant_budget_management.committee_type')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="budget_allocation.committee_type"
                                    id="committee_type"
                                    :options="committeeList"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                  >
                                  <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md= "6" lg="6" xl="6">
                              <ValidationProvider name="Division" vid="division_id" rules="required|min_value:1">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    :label-for="'division_id'"
                                    slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{$t('globalTrans.division')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="budget_allocation.division_id"
                                    id="division_id"
                                    :options="getDivisionList"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                  >
                                  <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md= "6" lg="6" xl="6">
                              <ValidationProvider name="District" vid="district_id" rules="required|min_value:1">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    :label-for="'district_id'"
                                    slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{$t('globalTrans.district')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="budget_allocation.district_id"
                                    id="district_id"
                                    :options="districtList"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                  >
                                  <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md= "6" lg="6" xl="6" v-if="visible">
                              <ValidationProvider name="Upazila" vid="upazila_id" rules="required|min_value:1">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    :label-for="'upazila_id'"
                                    slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{$t('globalTrans.upazila')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="budget_allocation.upazilla_id"
                                    id="upazila_id"
                                    :options="upazilaList"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                  >
                                  <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md= "6" lg="6" xl="6">
                              <ValidationProvider name="Bank name" vid='bank_name' rules="required">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="bank_name"
                                    slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{ $t('grant_budget_management.bank_name')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                      id="bank_name"
                                      v-model="budget_allocation.bank_name"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    </b-form-input>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md= "6" lg="6" xl="6">
                              <ValidationProvider name="Branch name (English)" vid='branch_name_en' rules="required">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="branch_name_en"
                                    slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{ $t('org_pro.branch_name')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                      id="branch_name_en"
                                      v-model="budget_allocation.branch_name"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    </b-form-input>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md= "6" lg="6" xl="6">
                              <ValidationProvider name="Branch name (Bangla)" vid='branch_name_bn' rules="required">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="branch_name_bn"
                                    slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{ $t('org_pro.branch_name_bn')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                      id="branch_name_bn"
                                      v-model="budget_allocation.branch_name_bn"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    </b-form-input>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md= "6" lg="6" xl="6">
                              <ValidationProvider name="Account no" vid='account_no' rules="required|numeric|min_value:1">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="account_no"
                                    slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{ $t('grant_budget_management.account_no')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                      disabled
                                      id="account_no"
                                      v-model="budget_allocation.account_no"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    </b-form-input>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col sm="12" md= "6" lg="6" xl="6">
                              <ValidationProvider name="Amount" vid='amount' :rules="{ required: true, max_value: budget_allocation.total_budget }">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="amount"
                                    slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{ $t('grant_budget_management.amount')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                      id="amount"
                                      v-model="budget_allocation.amount"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    </b-form-input>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>
                          </b-row>
                          <b-row>
                            <div class="col text-right">
                              <b-button type="submit" variant="primary" class="mr-2">
                                {{ $t('globalTrans.submit') }}
                              </b-button>
                            </div>
                          </b-row>
                        </b-form>
                      </ValidationObserver>
                    </b-overlay>
                  </b-col>
                </b-row>
            </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { grantAllowanceServiceBaseUrl } from '@/config/api_config'
import { budgetAllocationStoreApi, budgetAllocationUpdateApi, searchData, budgetAllocationDetailsApi } from '../../api/routes'

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      formLoader: false,
      visible: false,
      processId: 5,
      budget_allocation: {
        org_id: 0,
        fiscal_year_id: 0,
        service_type_id: 0,
        service_id: 0,
        committee_type: 0,
        division_id: 0,
        district_id: 0,
        upazilla_id: 0,
        total_budget: '',
        available_budget: '',
        bank_name: '',
        branch_name: '',
        branch_name_bn: '',
        account_no: 1234,
        amount: ''
      },
      serviceName: [],
      districtList: [],
      upazilaList: []
    }
  },
  created () {
    if (this.$route.query.id) {
      this.getData()
    }
  },
  mounted () {
  },
  computed: {
    organizationList () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
    committeeList () {
        const list = [
            { value: 1, text_en: 'District', text_bn: 'জেলা' },
            { value: 2, text_en: 'Upazila', text_bn: 'উপজেলা' }
        ]
        return list.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    serviceTypeList () {
      const objectData = this.$store.state.GrantAllowanceService.commonObj.serviceTypeList
      return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
          } else {
              return { value: obj.value, text: obj.text_en }
          }
      })
    },
    fiscalYearList () {
      return this.$store.state.commonObj.fiscalYearList
    },
    getDivisionList () {
      const objectData = this.$store.state.commonObj.divisionList
      return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
          } else {
              return { value: obj.value, text: obj.text_en }
          }
      })
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
      'budget_allocation.service_type_id': function (newVal) {
          this.serviceName = this.getServiceName(newVal)
      },
      'budget_allocation.division_id': function (newVal) {
          this.districtList = this.getDistrictList(newVal)
      },
      'budget_allocation.district_id': function (newVal) {
          this.upazilaList = this.getUpazilaList(newVal)
      },
      'budget_allocation.committee_type': function (newVal) {
          if (newVal === 1) {
              this.visible = false
          } else if (newVal === 2) {
              this.visible = true
          }
      },
      'budget_allocation.service_id': function () {
        this.formLoader = true
        RestApi.postData(grantAllowanceServiceBaseUrl, searchData, this.budget_allocation).then(response => {
            if (response.success) {
              this.budget_allocation.total_budget = parseInt(response.data.approve_amount) || ''
              this.budget_allocation.available_budget = parseInt(response.data.total_amount) || ''
              this.formLoader = false
            }
        })
      }
  },
  methods: {
    getDistrictList (id) {
        const objectData = this.$store.state.commonObj.districtList.filter(item => item.division_id === id)
        return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
          } else {
              return { value: obj.value, text: obj.text_en }
          }
        })
    },
    getUpazilaList (id) {
        const objectData = this.$store.state.commonObj.upazilaList.filter(item => item.district_id === id)
        return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
          } else {
              return { value: obj.value, text: obj.text_en }
          }
        })
    },
    getServiceName (id) {
        const objectData = this.$store.state.GrantAllowanceService.commonObj.serviceNameList.filter(item => item.service_type_id === id && item.service_process_id === this.processId)
        return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
          } else {
              return { value: obj.value, text: obj.text_en }
          }
        })
    },
    async saveData () {
      this.formLoader = true
      let result = null
      if (this.$route.query.id) {
        result = await RestApi.putData(grantAllowanceServiceBaseUrl, `${budgetAllocationUpdateApi}/${this.$route.query.id}`, this.budget_allocation)
      } else {
        result = await RestApi.postData(grantAllowanceServiceBaseUrl, budgetAllocationStoreApi, this.budget_allocation)
      }
      if (result.success) {
        this.formLoader = false
        this.$toast.success({
          title: this.$t('globalTrans.success'),
          message: this.$route.query.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
          color: '#D6E09B'
        })

        this.$router.push({ path: '/grant-allowance-service/budget-management/budget-allocation' })
      } else {
        if (result.errors) {
          this.$refs.form.setErrors(result.errors)
        }
      }
    },
    async getData () {
      this.formLoader = true
      if (this.$route.query.id) {
        await RestApi.getData(grantAllowanceServiceBaseUrl, `${budgetAllocationDetailsApi}/${this.$route.query.id}`)
        .then(response => {
          if (response.success) {
            this.formLoader = false
              this.budget_allocation = response.data
          }
        })
      }
    }
  }
}
</script>
